import { useAuth } from "context/AuthContext";
import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AppPath, UserRole, UserType } from "utils/constants";

function LoginLayout() {
  const { loginData } = useAuth();
  if (loginData.isLogin) {
    if (loginData.type === UserType.NTTsp) {
      return <Navigate to={AppPath.ServiceProvider} replace />;
    } else if (loginData.type === UserType.ServiceProvider) {
      return <Navigate to={AppPath.ServiceProvider} replace />;
    } else if (loginData.type === UserType.Tenant) {
      return <Navigate to={AppPath.TenantManagement} replace />;
    } else if (loginData.type === UserType.Location) {
      return <Navigate to={AppPath.Location} replace />;
    }
    return <Navigate to={AppPath.CameraManagement} replace />;
  }
  return (
    <>
      <Outlet />
    </>
  );
}

export default LoginLayout;
